import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Grid, withStyles} from '@material-ui/core'

import {Link} from 'react-router-dom'

import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import Edit from '@material-ui/icons/Edit'
import {ArrowToolTip, MenuButton} from '../../components/components'
import {apiResourcesUrl} from '../../core/request'

const styles = {
    coverImg: {
        alignSelf: 'center',
        marginTop: '1.5em',
        height: '7em',
        width: 'auto'
    },

    project: {
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer'
    },

    contentContainer: {
        display: 'flex',
        flexDirection: 'column'
    },

    imageContainer: {
        alignSelf: 'center'
    },

    link: {
        textDecoration: 'none'
    },

    projectTitle: {
        textAlign: 'center',
        backgroundColor: '#000',
        marginTop: '0.3em',
        padding: '0.1em',
        paddingLeft: '0.4em',
        paddingRight: '0.4em',
        color: '#fff',
        borderRadius: '0.2em'
    }
}


class ProjectThumb extends Component {
    menuOptions = [
        {label: 'View', icon: <RemoveRedEye />, linkTo: `/${this.props.projectData.id}`},
        {label: 'Change Cover', icon: <PhotoCamera />, linkTo: `/${this.props.projectData.id}/edit#media`},
        {label: 'Edit', icon: <Edit />, linkTo: `/${this.props.projectData.id}/edit`}
    ]

    content = (
        <div className={this.props.classes.contentContainer}>
            <ArrowToolTip className={this.props.classes.imageContainer} title={this.props.projectData.name}>
                <img alt={this.props.projectData.name} className={this.props.classes.coverImg} src={`${apiResourcesUrl}/cover-arts/${this.props.projectData.coverUrl}`} />
            </ArrowToolTip>
            {/* <Typography className={this.props.classes.projectTitle} variant={'subtitle1'}>{this.props.projectData.name}</Typography> */}
        </div>
    )

    asLink = (
        <Link to={`/${this.props.projectData.id}`} className={this.props.classes.link}>
            {this.content}
        </Link>
    )

    asMenuButton = (
        <MenuButton id={this.props.projectData.id} options={this.menuOptions}>
            {this.content}
        </MenuButton>
    )

    render() {
        const {classes: styles, user} = this.props

        return (
            <Grid item lg={2} xl={2} md={3} xs={6} sm={4} className={styles.project}>
                {user ? this.asMenuButton : this.asLink}
            </Grid>
        )
    }
}

ProjectThumb.propTypes = {
    classes: PropTypes.object,
    projectData: PropTypes.object.isRequired,
    user: PropTypes.object
}

export default withStyles(styles)(ProjectThumb);
